// Statsig's Events
export const STATSIG_EVENT_NAMES = {
    LISTING_APP_PAGE_VIEW: 'Listing - App - View - Page',
    LISTING_CONVERSION_BAR_CTA_CLICK: 'Listing - conversionBar - Click - CTA',
    LISTING_TICKET_SELECTION_VIEW:
        'Listing - Conversion Bar - Ticket Selection - View',
    LISTING_ALL_EVENT_DETAILS_VIEW:
        'Listing - All - Click - View All Event Details',
    LISTING_TICKET_SELECTION_CLICK:
        'Listing - Conversion Bar - Ticket Selection - Click',
    CHILD_EVENTS_DROPDOWN:
        'Listing - Select a date - Change - Child Events Dropdown',
    MORE_OPTIONS_BUTTON:
        'Listing - Select a date - Click - More Options Button',
    MORE_OPTIONS_CARD: 'Listing - Select a date - Click - More Options Card',
    CAROUSEL_CARD: 'Listing - Select a date - Click - Carousel card',
    LISTING_MORE_ORGANIZER_EVENT_CLICK:
        'Listing - All - Click - More Organizer Event',
    LISTING_MORE_ORGANIZER_EVENT_LIKE:
        'Listing - All - Click - More Organizer Event Like',
    LISTING_MORE_ORGANIZER_EVENT_SHARE:
        'Listing - All - Click - More Organizer Event Share',
    LISTING_RELATED_EVENT_CLICK: 'Listing - All - Click - Related Event',
    LISTING_RELATED_EVENT_LIKE: 'Listing - All - Click - Related Event Like',
    LISTING_RELATED_EVENT_SHARE: 'Listing - All - Click - Related Event Share',
    LISTING_SUBCATEGORY_CTA_CLICK:
        'Listing - Expired Event Page - Click - Category Browse Modal CTA',
    LISTING_FOLLOW_CLICK: 'Listing - All - Click - Follow',
    LISTING_UNFOLLOW_CLICK: 'Listing - All - Click - Unfollow',
    ABOUT_THIS_EVENT_VIEW: 'ListingWeb - Description - View',
    LISTING_ALL_SUCCESS_LIKE_EVENT: 'Listing - All - Success - Like Event',
    LISTING_NIGHTLIFE_EVENT_CLICK: 'Listing - All - Click - Nightlife Event',
    LISTING_NIGHTLIFE_EVENT_LIKE:
        'Listing - All - Click - Nightlife Event Like',
    LISTING_NIGHTLIFE_EVENT_SHARE:
        'Listing - All - Click - Nightlife Event Share',
    G2K_VIEW: 'ListingWeb - Good to know - ListingGoodToKnowView - View',
    G2K_VIEW_CARD:
        'ListingWeb - Good to know - ListingGoodToKnowViewCard - View',
    G2K_READ_MORE_CLICK:
        'ListingWeb - Good to know - ListingGoodToKnowReadMore - Click',
    G2K_VIEW_ALL_CLICK:
        'ListingWeb - Good to know - ListingGoodToKnowViewAll - Click',
    FAQ_VIEW: 'ListingWeb - Good to know - FAQ - View',
    HIGHLIGHTS_VIEW: 'ListingWeb - Good to know - Highlights - View',
    REFUND_POLICY_VIEW: 'ListingWeb - Good to know - RefundPolicy - View',
};

// Statsig's First Hierarchy Level Experiment for Listings Team
export const LISTING_VIDEO_AUTOPLAY_EXPERIMENT = {
    experimentName: 'listing_video_autoplay',
    param: 'show_autoplay_video',
    defaultValue: false,
};

export const LISTING_TEST_AA_SSR_EXPERIMENT = {
    experimentName: 'test_aa_ssr',
    param: 'test',
    defaultValue: false,
};

// Statsig's detach interests from user menu
export const DETACH_INTERESTS_FROM_USER_MENU = {
    experimentName: 'consumer_onboarding_detach_interests',
    param: 'detach_interests',
    defaultValue: false,
};

export enum NIGHTLIFE_EXPERIMENT_VALUES {
    CONTROL = 'hidden',
    TEST = 'visible',
}

export const NIGHTLIFE_CAROUSEL_EXPERIMENT = {
    experimentName: 'nightlife_carousel_listings',
    param: 'nightlife_carousel',
    defaultValue: NIGHTLIFE_EXPERIMENT_VALUES.CONTROL,
};

export const TIMED_ENTRY_SESSION_SELECTOR_EXPERIMENT = {
    experimentName: 'timed_entry_session_selector_experiment',
    param: 'hide_session_selector',
    defaultValue: false,
};

export enum TimedEntryPhase2CheckoutExperimentVariant {
    control = 'control',
    newExperience = 'timedEntryInfiniteCalendar',
}

export const LISTING_TIMED_ENTRY_CHECKOUT_EXPERIMENT = {
    experimentName: 'timed_entry_checkout_phase_2',
    param: 'show_timed_entry_infinite_calendar',
    defaultValue: TimedEntryPhase2CheckoutExperimentVariant.control,
};

export const LISTINGS_CONDENSED_CHECKOUT_EXPERIMENT = {
    experimentName: 'listings_condensed_checkout_bar',
    param: 'enabled',
    defaultValue: false,
};
